import { Col, Form, Input, message, Row } from "antd";
import React, { useState } from "react";
import s from "../Register/Register.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { getMyCars, resendOTP, verifyOTP } from "../../redux/carSlice";
import Countdown from "react-countdown";

const ActivateAccount = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const [form] = useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const email = useSelector((state) => state.cars.email);
  const successMessage = useSelector((state) => state.cars.message);
  const [remainingTime, setRemainingTime] = useState(() => Date.now() + 60000);
  const [responseMessage, setResponseMessage] = useState();

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message ? message : "Ваш профиль успешно активирован!",
    });
  };

  const error = (error) => {
    messageApi.open({
      type: "error",
      content: error ? error : "ОТП код неверный!",
    });
  };

  console.log("remaining", remainingTime);

  const activateUser = async (values) => {
    try {
      const res = await dispatch(
        verifyOTP({
          email: email,
          otp: values.otp.toString(),
        })
      );

      console.log("res2", res);

      if (res.type === "user/verifyOTP/fulfilled") {
        setRemainingTime(Date.now() + 60000);
        success();

        navigate("/login");
      }

      if (res.type === "user/resendOtp/rejected") {
        error(res.payload.message);
        setRemainingTime(Date.now() + res.payload.remaining_time * 1000);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const sendOTP = async () => {
    try {
      const res = await dispatch(
        resendOTP({
          email: email,
        })
      );
      if (res.type === "user/resendOtp/fulfilled") {
        console.log("Date.now() + 60000", Date.now() + 60000);
        setRemainingTime(Date.now() + 60000);
        success("На вашу почту был повторно отправлен ОТП код");
      }

      if (res.type === "user/resendOtp/rejected") {
        error("ОТП код может запрашиваться только каждые 60 секунд");
        setRemainingTime(Date.now() + res?.payload?.remaining_time * 1000);
      }
      console.log("res", res);
    } catch (err) {
      console.log("err", err);
    }
  };

  const Completionist = () => <span>{""}</span>;

  const renderer = ({ seconds, completed }) => {
    if (completed) {
      return (
        <div>
          <Completionist />
        </div>
      );
    } else {
      return (
        <div className={s.message}>
          Код действителен в течение:{" "}
          <span className={s.seconds}>{seconds}</span> секунд
        </div>
      );
    }
  };

  return (
    <div className={s.login}>
      {contextHolder}
      <h2 className={s.h2}>
        <img src='/cncars_logo.png' className={s.logo} /> Активировать профиль
      </h2>

      <Form
        className={s.form}
        layout='vertical'
        form={form}
        onFinish={activateUser}
        style={{ width: "500px" }}
      >
        <div>
          {remainingTime && (
            <Countdown date={remainingTime} renderer={renderer} />
          )}
        </div>

        <Row>
          <Col span={24}>
            <Form.Item
              name='otp'
              label='Введите ОТП код отправленный на ваш email'
              rules={[
                {
                  required: true,
                  message: "Введите ОТП код отправленный на ваш email",
                },
                { len: 6, message: "ОТП код должен содержать 6 цифр" },
              ]}
            >
              <input placeholder='Введите ОТП' className={s.input} />
            </Form.Item>
          </Col>
        </Row>
        <div className={s.row}>
          <div className={s.forgetPassword} onClick={() => sendOTP()}>
            Запросить код еще раз
          </div>
        </div>
        <Row>
          <button className={s.enter_btn} type='htmlSubmit'>
            Активировать
          </button>
        </Row>
        <div className={s.no_account}>
          Нет аккаунта? &nbsp;
          <Link to='/register' className={s.register_btn}>
            Зарегестрироваться
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default ActivateAccount;
